import React, { useState, useEffect, useRef } from "react";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import bin from "../../assets/icons/LightBin.svg";
import { useLocation } from "react-router-dom";
import {
  FetchTaskByProject,
  GlobalRequest,
  UpdatePOTaskStatus,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import AddTaskModal from "../Dailogs/AddTaskModal";
import { API_URL } from "../../redux/constants/type";
import axios from "axios";
import {
  AddComments,
  deleteTask,
  ChangeStatus,
} from "../../redux/actions/action";
import moment from "moment";
import { ROLES } from "../../utils/helpers/userRole";
import TasDelete from "../../components/Dailogs/TaskDelete";
import TaskErrorPopup from "../Dailogs/TaskErrorPopup";
import CancelWarningModal from "../Dailogs/CancelWarningModal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddTask = ({
  showModal,
  setShowModal,
  taskList,
  setTaskList,
  pageNumber,
  setPageNumber,
  itemsPerPage,
  setItemsPerPage,
  totalPages,
  setTotalPages,
  totalItems,
  setTotalItems,
  pagesArray,
  setPagesArray,
  popups,
  setPopups,
  textAreaRef,
  reRenderAPI,
  setReRenderAPI,
  val,
  setVal,
  modalFunctionNoty,
  setModalFunctionNoty,
  modelTypeId,
  setModelTypeId,
  taskid,
  setTaskid,
  comments,
  setComments,
  minComments,
  setMinComments,
  maxComments,
  setMaxComments,
  modalFunction,
  setModalFunction,
  enablecomm,
  setEnableComm,
  showcmnt,
  setShowcmnt,
  message,
  setMessage,
  inputFile,
  imgUrl,
  setImgUrl,
  attachMessage,
  setAttachMessage,
  taggedUser,
  setTaggedUser,
  show,
  setShow,
  length,
  setLength,
  from,
  setFrom,
  searchText,
  setSearchText,
  showError,
  setShowError,
  statusList,
  setStatusList,
  isBasicMember,
  setIsBasicMember,
  isBuildingBlock,
  setIsBuildingBlock,
  onButtonClick,
  handleAddComments,
  handleFileChange,
  fetchComments,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const projectId = window.localStorage.getItem("projectid");
  const userId = window.localStorage.getItem("userid");
  const roleid = window.localStorage.getItem("roleid");

  const fetchTaskByProjectResponse = useSelector(
    (state) => state.user.fetchTaskByProjectResponse
  );
  const deleteTaskResponse = useSelector(
    (state) => state.user.deleteTaskResponse
  );
  const UpdatePOTaskStatusResponse = useSelector(
    (state) => state.user.UpdatePOTaskStatusResponse
  );
  const changeStatus = useSelector((state) => state.user.changeStatus);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes
  );

  useEffect(() => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      })
    );
  }, []);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  useEffect(() => {
    // if (location?.pathname === "/updateProject") {
    if (location?.pathname.startsWith("/project/")) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [location, pageNumber]);

  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  useEffect(() => {
    if (fetchTaskByProjectResponse?.status === true) {
      setTaskList(fetchTaskByProjectResponse?.data);

      // ASC for toggle start
      let filterdItem = fetchTaskByProjectResponse?.data
        .filter((x) => x.statusname === "Complete")
        .map((item) => {
          return {
            // pushedName: item.statusname,
            pushedName: item.taskname,
            pushedID: item.taskid,
          };
        });
      setSelectedToggle(filterdItem);
      // ASC for toggle end

      let pages = Math.ceil(
        fetchTaskByProjectResponse?.totalCount / itemsPerPage
      );
      setTotalPages(pages);
      setTotalItems(fetchTaskByProjectResponse?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      setPagesArray([...array]);
    }
  }, [fetchTaskByProjectResponse]);

  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  useEffect(() => {
    if (changeStatus?.status === true) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [changeStatus]);

  useEffect(() => {
    if (deleteTaskResponse?.status === true) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [deleteTaskResponse]);

  useEffect(() => {
    if (UpdatePOTaskStatusResponse?.status === true) {
      dispatch(FetchTaskByProject(projectId, pageNumber, itemsPerPage));
    }
  }, [UpdatePOTaskStatusResponse]);

  const [showPopup, setShowPopup] = useState(false);
  const [taskIdforDelete, setTaskIdforDelete] = useState("");

  const handleDelete = (e) => {
    dispatch(deleteTask(taskIdforDelete));
    setShowPopup(false);
  };

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [toggleComplete, setToggleComplete] = useState(false);
  const [ascTaskid, setAscTaskid] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedToggle, setSelectedToggle] = useState([]);

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions.every(
          (x) =>
            x.packageName.toUpperCase() == "BASIC" &&
            x.packageId == process.env.REACT_APP_IS_BASIC
        );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal =
        getAppSideNavOptions &&
        Array.isArray(getAppSideNavOptions) &&
        getAppSideNavOptions.every(
          (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM
        );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);

  return (
    <>
      {showPopup && (
        <TasDelete
          animation={true}
          handleDelete={handleDelete}
          show={showPopup}
          onHide={() => setShowPopup(false)}
        />
      )}

      {popups && (
        <CancelWarningModal
          show={popups}
          onHide={() => setPopups(false)}
          backdrop="static"
          keyboard={false}
          handleCancel={() => {
            setShowModal(false);
            setPopups(false);
          }}
        />
      )}

      <AddTaskModal
        isBasicMember={isBasicMember}
        isBuildingBlock={isBuildingBlock}
        val={val}
        setVal={setVal}
        textAreaRef={textAreaRef}
        modelTypeId={modelTypeId}
        showModal={showModal}
        modalFunctionNoty={modalFunctionNoty}
        setTaskid={setTaskid}
        taskid={taskid}
        setShowModal={(show, reload) => {
          setShowModal(false);
          window.localStorage.removeItem("taskid");
        }}
        setComments={setComments}
        modalFunction={modalFunction}
        setModalFunction={setModalFunction}
        setEnableComm={setEnableComm}
        setShowcmnt={setShowcmnt}
        enablecomm={enablecomm}
        showcmnt={showcmnt}
        setMessage={setMessage}
        message={message}
        onButtonClick={onButtonClick}
        handleFileChange={handleFileChange}
        handleAddComments={handleAddComments}
        maxComments={maxComments}
        taggedUser={taggedUser}
        setTaggedUser={setTaggedUser}
        show={show}
        length={length}
        setLength={setLength}
        setShow={setShow}
        imgUrl={imgUrl}
        setImgUrl={setImgUrl}
        setMaxComments={setMaxComments}
        from={from}
        searchText={searchText}
        setReRenderAPI={setReRenderAPI}
        setPopups={setPopups}
        statusList={statusList}
      />
      <TaskErrorPopup
        showError={showError}
        setShowError={setShowError}
        setAttachMessage={setAttachMessage}
        attachMessage={attachMessage}
        setImgUrl={setImgUrl}
      />

      <div className="quotes-main-container-mobile-position">
        <div className="quotes-div-1 fr">
          <section
            className="fr"
            style={{ gap: "7px", alignItems: "center", cursor: "pointer" }}
            onClick={() => {
              setModalFunction("add");
              setShowModal(true);
            }}
          >
            {roleid !== ROLES.VIEWER && (
              <>
                <img src={CardAddButton} className="addDocImg" alt="Add Icon" />
                <p className="addDocText mb-0">
                  {/* Add Task */}
                  {/* {FetchTranslationList[97]?.translation} */}
                  {t("Add Task")}
                </p>
              </>
            )}
          </section>
          <section className="fr quotes-div-sec-2" style={{ gap: "7px" }}>
            <p>
              {pageNumber === 1 ? 1 : itemsPerPage * (pageNumber - 1) + 1}-
              {itemsPerPage * pageNumber > totalItems
                ? totalItems
                : itemsPerPage * pageNumber}
            </p>
            <p>of</p>
            <p>{totalItems}</p>
            <p
              className="aro-lr"
              onClick={() => {
                if (pageNumber === 1) return;
                setPageNumber((p) => p - 1);
              }}
            >
              {"<"}
            </p>
            <p className="quote-current-page">{pageNumber}</p>
            <p
              className="aro-lr"
              onClick={() => {
                if (pageNumber >= totalPages) return;
                setPageNumber((p) => p + 1);
              }}
            >
              {">"}
            </p>
          </section>
        </div>
        <div
          className="task-main-grid"
          style={{
            marginTop: "30px",
            gridTemplateColumns:
              roleid === ROLES.VIEWER
                ? "1fr 0.5fr 0.4fr 0.2fr"
                : "50px 1fr 0.5fr 0.4fr 0.2fr",
          }}
        >
          {roleid !== ROLES.VIEWER && (
            <p className="task-grid-element hide-on-mobile">
              {/* Actions */}
              {t("Actions")}
            </p>
          )}
          <p className="task-grid-element task-postion">
            {/* Task Name */}
            {t("Task Name")}
          </p>
          <p className="task-grid-element hide-on-mobile">
            {/* Deadline */}
            {t("Deadline")}
          </p>
          <p className="task-grid-element hide-on-mobile">
            {/* Priority */}
            {t("Priority")}
          </p>
          <p className="task-grid-element mobile-view-postion">
            {/* Complete ? */}
            {t("Complete?")}
          </p>
        </div>

        {taskList?.map((task, index) => {
          return (
            <div
              className="task-main-grid"
              style={{
                marginTop: "22px",
                gridTemplateColumns:
                  roleid === ROLES.VIEWER
                    ? "1fr 0.5fr 0.4fr 0.2fr"
                    : "50px 1fr 0.5fr 0.4fr 0.2fr",
              }}
              key={index}
            >
              {roleid !== ROLES.VIEWER && (
                <article
                  style={{ textAlign: "center", cursor: "pointer" }}
                  onClick={() => {
                    setShowPopup(true);
                    setTaskIdforDelete(task?.taskid);
                  }}
                >
                  <img className="task-grid-element-2" src={bin} alt="" />
                </article>
              )}
              <p
                className="task-grid-element-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setModalFunction("update");
                  setTaskid(task?.taskid);
                  setShowModal(true);
                  setReRenderAPI(true);
                }}
              >
                {task?.taskname}
              </p>
              <article className="task-grid-element-2 fr">
                <p class="hide-on-mobile">
                  {moment(task?.duedatetime).format("DD.MM.YYYY")}
                </p>
                <p id="ml-12-imp" class="hide-on-mobile">
                  {/* {new Date(task?.duedatetime).getHours()}:
                  {new Date(task?.duedatetime).getMinutes()} */}

                  {new Date(task?.duedatetime).getHours() === 0
                    ? "00:00"
                    : `${new Date(task?.duedatetime).getHours()} :` +
                      `${new Date(task?.duedatetime).getMinutes()}`}
                </p>
              </article>

              <p className="task-grid-element-2" class="hide-on-mobile">
                {task?.priority}
              </p>
              <div className="task-grid-element-2 slide-bar-position-inmobile">
                <article
                  className={
                    selectedToggle.find((data) => data.pushedID === task.taskid)
                      ? "task_slider_Comp"
                      : "task_slider"
                  }
                  style={{
                    backgroundColor:
                      task?.statusname === "Complete" && "#00246a",
                  }}
                  onClick={(e) => {
                    let index2 = selectedToggle.findIndex(
                      (x) => x.pushedID === task.taskid,
                    );

                    if (index2 !== -1) {
                      let data = [...selectedToggle];
                      data.splice(index2, 1);
                      setSelectedToggle(data);
                      dispatch(
                        ChangeStatus(
                          task?.taskid,
                          process.env.REACT_APP_TASK_STATUS_PROGRESS,
                        ),
                      );
                      return;
                    }
                    let pushingItem = [...selectedToggle];
                    pushingItem.push({
                      pushedName: task.taskname,
                      pushedID: task.taskid,
                    });
                    setSelectedToggle(pushingItem);

                    // if (index2 === -1) {
                    //   let pushingItem = [...selectedToggle];
                    //   pushingItem.push({
                    //     pushedName: task.taskname,
                    //     pushedID: task.taskid,
                    //   });
                    //   setSelectedToggle(pushingItem);
                    // }

                    dispatch(UpdatePOTaskStatus(task?.taskid));
                    setToggleComplete(!toggleComplete);
                    setAscTaskid(task.taskid);
                    setCurrentIndex(index);
                  }}
                >
                  <article
                    className={
                      selectedToggle.find(
                        (data) => data.pushedID === task.taskid,
                      )
                        ? "task_slider_knob_Comp"
                        : "task_slider_knob"
                    }
                    style={{
                      left: task?.statusname === "Complete" && "46%",
                    }}
                  ></article>
                </article>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default AddTask;
